import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { EMAIL_ENTITY_TYPE } from "@miplatform/constants";
import { IAttempt, IStep } from "@miplatform/types";
import { EmailForm, useEmailForm } from "@mibuildweb/components";
import { Box } from "@mui/material";

interface WorkOrderAttemptEmailFormProps {
  attempt: IAttempt;
  step: IStep | null;
  templateType: string;
  isViewMode?: boolean;
  onClose: () => void;
}

export const WorkOrderAttemptEmailForm: FC<WorkOrderAttemptEmailFormProps> = ({
  attempt,
  step,
  templateType,
  isViewMode,
  onClose,
}) => {
  const { theme } = useStyles();
  const emailFormViewModel = useEmailForm({
    entity: attempt,
    step,
    templateType,
    onClose,
  });

  return isViewMode ? (
    <Box />
  ) : (
    <Box flexGrow={1} pb={2}>
      <EmailForm
        showHeader
        entityType={EMAIL_ENTITY_TYPE.ATTEMPT}
        viewModel={emailFormViewModel}
        containerStyle={{
          borderRadius: theme.spacing(1),
          border: `1px solid ${theme.palette.grey.accent}`,
        }}
        formContainerStyle={{
          backgroundColor: (theme.palette.grey as any).light,
        }}
      />
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  footer: {
    backgroundColor: theme.palette.common.white,
    position: "sticky",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(4),
    padding: theme.spacing(2, 0),
    zIndex: theme.zIndex.drawer,
  },
  cancelBtn: {
    color: theme.palette.common.black,
    fontWeight: theme.typography.fontWeightBold,
  },
  confirmBtn: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));
